import React, { useState, useRef } from 'react';
import './Experience.css';
import { X, ChevronLeft, ChevronRight, ExternalLink, Play, Sparkles, Film, Gamepad, User, Briefcase } from 'lucide-react';

const projectsData = [
  {
    id: 'kristala',
    title: 'Kristala',
    role: 'Cinematic Artist',
    company: 'Astral Clocktower Studios',
    description: 'Responsible for creating cinematic sequences for the official trailer, commercial videos, and in-game cutscenes using Unreal Engine for this dark fantasy ARPG. The role involved digital camera composition, dramatic lighting, and video editing.',
    category: 'games',
    image: '/assets/img/portfolio/astralclockwork/LS_Character_Shown02.jpg',
    hoverVideo: '/assets/img/portfolio/astralclockwork/Character_Showcase10.mp4',
    technologies: ['Unreal Engine', 'Premiere Pro', 'DaVinci Resolve', 'Cinematic Art'],
    year: '2023',
    externalLink: 'https://youtu.be/zC1RmbiDw78?si=bvwDkRJTglEAsGs4',
    assets: [
      { type: 'image', src: '/assets/img/portfolio/astralclockwork/LS_Character_Shown02.jpg', title: 'Kristala Character' },
      { type: 'video', src: '/assets/img/portfolio/astralclockwork/Character_Showcase10.mp4', title: 'Character Showcase Video' },
      { type: 'video', src: '/assets/img/portfolio/astralclockwork/Crystals shot.mov', title: 'Crystals Shot Video' }
    ]
  },
  {
    id: 'ecowarriors',
    title: 'EcoWarriors',
    role: 'Environment & Cinematic Artist',
    company: 'Rupture',
    description: 'Developed 3D environments and cinematic scenes for this educational Virtual Reality (VR) game commissioned by the Maltese government. The project aimed to raise awareness and educate citizens on ecology, recycling, and environmental sustainability.',
    category: 'games',
    image: '/assets/img/portfolio/videogames/ecowarriors/ecowarriors.png',
    hoverVideo: '/assets/img/portfolio/videogames/ecowarriors/ecowarriors.mp4',
    technologies: ['Unreal Engine 5', 'VR', 'Environment Art', 'CGI'],
    year: '2024',
    assets: [
      { type: 'image', src: '/assets/img/portfolio/videogames/ecowarriors/ecowarriors.png', title: 'EcoWarriors Environment' },
      { type: 'video', src: '/assets/img/portfolio/videogames/ecowarriors/ecowarriors.mp4', title: 'EcoWarriors Walkthrough Video' },
      { type: 'video', src: '/assets/img/portfolio/videogames/ecowarriors/ecowarriorsanim.mp4', title: 'EcoWarriors Animation Showcase' },
      { type: 'image', src: '/assets/img/portfolio/videogames/ecowarriors/ecowarriorsvid.png', title: 'EcoWarriors Gameplay Screenshot' }
    ]
  },
  {
    id: 'tammy',
    title: 'Tammy',
    role: '3D Character Artist & Animator',
    company: 'Turi Animation',
    description: 'Complete development in Blender of the 3D character Tammy for a series of educational road-safety cartoons for children, augmented reality (AR) apps, and commercials for the Maltese government. Created the character rig and animations from scratch.',
    category: 'cartoons',
    image: '/assets/img/portfolio/cartoon/Tammy/tammy.png',
    hoverVideo: '/assets/img/portfolio/cartoon/Tammy/tammy-3D.mp4',
    technologies: ['Blender', 'Character Rigging', '3D Animation', 'AR Assets'],
    year: '2024',
    assets: [
      { type: 'image', src: '/assets/img/portfolio/cartoon/Tammy/tammy.png', title: 'Tammy Character Render' },
      { type: 'image', src: '/assets/img/portfolio/cartoon/Tammy/Tammy rig.png', title: 'Tammy Rigging System' },
      { type: 'video', src: '/assets/img/portfolio/cartoon/Tammy/tammy-3D.mp4', title: 'Tammy 3D Animation Test' },
      { type: 'video', src: '/assets/img/portfolio/cartoon/Tammy/0001-0145.mp4', title: 'Tammy Final Render Scene' },
      { type: 'video', src: '/assets/img/portfolio/cartoon/Tammy/Take1.mp4', title: 'Tammy Character Animation Take 1' }
    ]
  },
  {
    id: 'turi-studio',
    title: 'Id-Do & Id-Di',
    role: '3D Character Artist',
    company: 'Turi Animation',
    description: 'Modeling, texturing, and rendering in Blender of the 3D characters Id-Do and Id-Di, inspired by a popular Maltese idiom. The characters were featured in a mixed 2D/3D animated series and various commercial advertisements.',
    category: 'cartoons',
    image: '/assets/img/portfolio/cartoon/turi/ID-DI.jpg',
    hoverVideo: '/assets/img/portfolio/cartoon/turi/Id-Do_Id-Di.mp4',
    technologies: ['Blender', 'Character Art', 'CGI', 'Texturing'],
    year: '2024',
    assets: [
      { type: 'image', src: '/assets/img/portfolio/cartoon/turi/ID-DI.jpg', title: 'ID-DI Character Render' },
      { type: 'image', src: '/assets/img/portfolio/cartoon/turi/ID-DO.jpg', title: 'ID-DO Character Render' },
      { type: 'image', src: '/assets/img/portfolio/cartoon/turi/Id-Di and Id-Do.png', title: 'Id-Di & Id-Do Group Shot' },
      { type: 'image', src: '/assets/img/portfolio/cartoon/turi/Id-Do_Id-Di.png', title: 'Id-Di & Id-Do Studio Setup' },
      { type: 'video', src: '/assets/img/portfolio/cartoon/turi/Id-Do_Id-Di.mp4', title: 'Id-Di & Id-Do Animation Showcase' }
    ]
  },
  {
    id: 'faqusu',
    title: 'Faqusu',
    role: 'Motion Capture Animator',
    company: 'Rupture',
    description: 'Managed and cleaned up motion capture data recorded with sensor suits, integrating it into complex animated scenes in Blender for the second season of the animated series.',
    category: 'cartoons',
    image: '/assets/img/portfolio/cartoon/cartoon-3-image.png',
    hoverVideo: '/assets/img/portfolio/cartoon/cartoon-3.mp4',
    technologies: ['Motion Capture', 'Blender', 'Animation Cleanup'],
    year: '2024',
    assets: [
      { type: 'image', src: '/assets/img/portfolio/cartoon/cartoon-3-image.png', title: 'Faqusu Character Design' },
      { type: 'video', src: '/assets/img/portfolio/cartoon/cartoon-3.mp4', title: 'Mocap Animation Showcase' }
    ]
  },
  {
    id: 'con-te',
    title: 'Con te',
    role: 'MoCap Artist & Animator',
    company: 'Pepito Production',
    comingSoon: true,
    description: 'I worked closely with the movie director to record the Motion Capture for this movie, I also worked on the layout and cleaned up the animation for the final rendering.',
    category: 'cartoons',
    image: '/assets/img/portfolio/cartoon/conte/Con-te1.jpg',
    hoverVideo: null,
    technologies: ['3D Animation', 'Character Art', 'CGI', 'Feature Film'],
    year: '2024',
    assets: [
      { type: 'image', src: '/assets/img/portfolio/cartoon/conte/Con-te1.jpg', title: 'Con te - Scene 1' },
      { type: 'image', src: '/assets/img/portfolio/cartoon/conte/Con-te2.jpg', title: 'Con te - Scene 2' },
      { type: 'image', src: '/assets/img/portfolio/cartoon/conte/Con-te3.jpg', title: 'Con te - Scene 3' },
      { type: 'image', src: '/assets/img/portfolio/cartoon/conte/Con-te4.jpg', title: 'Con te - Scene 4' },
      { type: 'image', src: '/assets/img/portfolio/cartoon/conte/Con-te5.jpg', title: 'Con te - Scene 5' }
    ]
  },
  {
    id: 'il-gigante',
    title: 'Il gigante',
    role: 'MoCap Artist & Anim Supervisor',
    company: 'Pepito Production',
    comingSoon: true,
    description: 'I worked closely with the movie director to record the Motion Capture for this movie, then I established a pipeline to polish the animations coming from the mocap, managed the technical side of Blender and provided feedback to the animators.',
    category: 'cartoons',
    image: '/assets/img/portfolio/cartoon/il-gigante/Il-gigante.jpg',
    hoverVideo: null,
    technologies: ['3D Animation', 'Environment Art', 'CGI', 'Feature Film'],
    year: '2024',
    assets: [
      { type: 'image', src: '/assets/img/portfolio/cartoon/il-gigante/Il-gigante.jpg', title: 'Il gigante - Feature Frame' }
    ]
  },
  {
    id: 'pokeball',
    title: 'Pokeball Re-creation',
    role: '3D Artist (Personal Project)',
    company: 'Personal Project',
    description: 'Accurate polygonal modeling and photorealistic texturing of a Pokeball. Studied wear on industrial metals and glossy plastics using Substance Painter. The project includes high-resolution final renders and Clay renders for mesh topology analysis.',
    category: 'personal',
    image: '/assets/img/portfolio/pokeball/Final render_1.2.1.png',
    hoverVideo: null,
    technologies: ['Blender', 'Substance Painter', 'Realistic Rendering', 'Clay Render'],
    year: '2023',
    assets: [
      { type: 'image', src: '/assets/img/portfolio/pokeball/Final render_1.2.1.png', title: 'Pokeball Final Render' },
      { type: 'image', src: '/assets/img/portfolio/pokeball/antonino-cuti-highresscreenshot00002.jpg', title: 'Clay Topology Render' },
      { type: 'image', src: '/assets/img/portfolio/pokeball/antonino-cuti-screenshot-2023-12-21-172155.jpg', title: 'Reference Setup' }
    ]
  },
  {
    id: 'hudson',
    title: 'Hudson Spot',
    role: '3D & Cinematic Artist',
    company: 'Turi Animation',
    description: 'Created dynamic animations and CGI for the Hudson brand. Modeled and placed products within high-impact environments in Blender, managing camera physical movement and material accuracy.',
    category: 'commercials',
    image: '/assets/img/portfolio/commercial/hudson.png',
    hoverVideo: '/assets/img/portfolio/commercial/Hudson.mp4',
    technologies: ['Blender', 'CGI', 'Commercial Spot', 'Lighting'],
    year: '2024',
    assets: [
      { type: 'image', src: '/assets/img/portfolio/commercial/hudson.png', title: 'Hudson Promo Frame' },
      { type: 'video', src: '/assets/img/portfolio/commercial/Hudson.mp4', title: 'Hudson Commercial Video' }
    ]
  },
  {
    id: 'oriental-garden-1',
    title: 'Oriental Garden',
    role: 'VFX Artist',
    company: 'Turi Animation',
    description: 'This is part 1 of a commercial shot aimed to tease the new opening of a fast food chain named Oriental Garden in Birkirkara (Malta). I took care of the filming, 3D, Rendering and compositing.',
    category: 'commercials',
    image: '/assets/img/portfolio/commercial/oriental_garden.png',
    hoverVideo: '/assets/img/portfolio/commercial/oriental_garden.mp4',
    technologies: ['Unreal Engine 5', 'Environment Design', 'Lighting Design', 'Water Shaders'],
    year: '2024',
    assets: [
      { type: 'image', src: '/assets/img/portfolio/commercial/oriental_garden.png', title: 'Oriental Garden View 1' },
      { type: 'video', src: '/assets/img/portfolio/commercial/oriental_garden.mp4', title: 'Oriental Garden Showcase 1' }
    ]
  },
  {
    id: 'oriental-garden-2',
    title: 'Oriental Garden 2',
    role: 'VFX Artist',
    company: 'Turi Animation',
    description: 'This is part 2 of a commercial shot aimed to tease the new opening of a fast food chain named Oriental Garden in Birkirkara (Malta). I took care of the filming, 3D, Rendering and compositing.',
    category: 'commercials',
    image: '/assets/img/portfolio/commercial/oriental_garden_2.png',
    hoverVideo: '/assets/img/portfolio/commercial/oriental_garden_2.mp4',
    technologies: ['Unreal Engine 5', 'Environment Design', 'Lighting Design', 'Water Shaders'],
    year: '2024',
    assets: [
      { type: 'image', src: '/assets/img/portfolio/commercial/oriental_garden_2.png', title: 'Oriental Garden View 2' },
      { type: 'video', src: '/assets/img/portfolio/commercial/oriental_garden_2.mp4', title: 'Oriental Garden Showcase 2' }
    ]
  },
  {
    id: 'palermo-liberty',
    title: 'Villa Liberty Palermo',
    role: 'VR Project - Photogrammetry',
    company: 'Palermo Rewind',
    description: '3D digital and architectural reconstruction of a historic Art Nouveau (Liberty style) villa in Palermo. The model was developed from historical blueprints and photogrammetry, focusing on accurate period decorations and structural fidelity for VR experience.',
    category: 'commercials',
    image: '/assets/img/portfolio/other/palermo-liberty.jpeg',
    hoverVideo: null,
    technologies: ['VR', 'Photogrammetry', '3D Reconstruction', 'Blender'],
    year: '2024',
    assets: [
      { type: 'image', src: '/assets/img/portfolio/other/palermo-liberty.jpeg', title: 'Final Architectural Render' },
      { type: 'image', src: '/assets/img/portfolio/other/palermo-liberty2.jpeg', title: 'Wireframe Modeling Mesh' }
    ]
  },
  {
    id: 'kids',
    title: 'Kids CGI',
    role: 'VFX Artist',
    company: 'David Williams',
    description: 'Modeling and animation of stylized characters and props for a children-focused advertising campaign. Special focus was placed on color vibrancy and smooth character movements.',
    category: 'commercials',
    image: '/assets/img/portfolio/commercial/kid.png',
    hoverVideo: '/assets/img/portfolio/commercial/Kids.mp4',
    technologies: ['Blender', '3D Animation', 'Character Expression', 'Color Grading'],
    year: '2024',
    assets: [
      { type: 'image', src: '/assets/img/portfolio/commercial/kid.png', title: 'Kids Character Render' },
      { type: 'video', src: '/assets/img/portfolio/commercial/Kids.mp4', title: 'Kids Commercial Spot' }
    ]
  },
  {
    id: 'policebot',
    title: 'Police Robot',
    role: 'Hard Surface Modeler',
    company: 'Study Project',
    description: 'High-definition rendering of an armored police robot, created during studies at CG Spectrum. Modeling focused on complex industrial components, pistons, and steel joints.',
    category: 'personal',
    image: '/assets/img/portfolio/other/policebot.jpeg',
    hoverVideo: null,
    technologies: ['Maya', 'ZBrush', 'Hard Surface Modeling', 'Substance Painter'],
    year: '2024',
    assets: [
      { type: 'image', src: '/assets/img/portfolio/other/policebot.jpeg', title: 'Police Robot Final Render' }
    ]
  },
  {
    id: 'endless-engine',
    title: 'Endless Engine Challenge',
    role: '3D & VFX Artist',
    company: 'Personal Project (Competition)',
    description: 'Entry for the global computer graphics contest "Endless Engine Challenge" (2024). Dynamic simulation and animation created in Unreal Engine 5 using motion capture suits and volumetric fluids for car smoke.',
    category: 'personal',
    image: '/assets/img/testimonials-bg.jpg',
    hoverVideo: '/assets/img/portfolio/other/AntoninoCuti_EE.mp4',
    technologies: ['Unreal Engine 5', 'VFX', 'Physics Simulation', 'Motion Capture'],
    year: '2024',
    assets: [
      { type: 'image', src: '/assets/img/testimonials-bg.jpg', title: 'Challenge Cover Frame' },
      { type: 'video', src: '/assets/img/portfolio/other/AntoninoCuti_EE.mp4', title: 'Endless Engine Animation' }
    ]
  },
  {
    id: 'pirate-sea',
    title: "Pirate's Sea",
    role: 'Environment & VFX Artist',
    company: 'Personal Project',
    description: 'Ocean simulation project created entirely in Unreal Engine 5. The primary focus was studying the dynamic behavior of stormy waves, light refraction through water, and collision foam against a pirate ship hull.',
    category: 'personal',
    image: '/assets/img/portfolio/personal_projects/pirates-sea-image.png',
    hoverVideo: '/assets/img/portfolio/personal_projects/AntoninoCuti_Pirate\'sSea.mp4',
    technologies: ['Unreal Engine 5', 'Water Shader', 'Atmospheric Fog', 'Physics Simulation'],
    year: '2024',
    assets: [
      { type: 'image', src: '/assets/img/portfolio/personal_projects/pirates-sea-image.png', title: 'Pirate Sea Concept Frame' },
      { type: 'video', src: '/assets/img/portfolio/personal_projects/AntoninoCuti_Pirate\'sSea.mp4', title: 'Pirate Sea Video Showcase' }
    ]
  },
  {
    id: 'temple-mountain',
    title: 'Temple on a Mountain',
    role: 'Landscape & Environment Artist',
    company: 'Personal Project',
    description: 'Majestic 3D scene depicting a temple perched on snowy mountain peaks. The terrain was generated in Gaea and integrated into Unreal Engine 5 for set dressing, volumetric fog, and sunrise lighting calibration.',
    category: 'personal',
    image: '/assets/img/portfolio/personal_projects/temple-image.png',
    hoverVideo: '/assets/img/portfolio/personal_projects/AntoninoCuti_TempleOnAMountain.mp4',
    technologies: ['Unreal Engine 5', 'Gaea Terrain', 'Landscape Art', 'Volumetric Fog'],
    year: '2024',
    assets: [
      { type: 'image', src: '/assets/img/portfolio/personal_projects/temple-image.png', title: 'Temple Mountain View' },
      { type: 'video', src: '/assets/img/portfolio/personal_projects/AntoninoCuti_TempleOnAMountain.mp4', title: 'Temple Mountain Cinematic Video' }
    ]
  }
];

const categories = [
  { id: 'all', label: 'All Projects', icon: Sparkles },
  { id: 'commercials', label: 'Commercials', icon: Briefcase },
  { id: 'cartoons', label: 'Cartoons', icon: Film },
  { id: 'games', label: 'Games', icon: Gamepad },
  { id: 'personal', label: 'Personal', icon: User }
];

const ProjectCard = ({ project, onOpen }) => {
  const [isHovered, setIsHovered] = useState(false);
  const videoRef = useRef(null);

  const handleMouseEnter = () => {
    setIsHovered(true);
    if (videoRef.current) {
      videoRef.current.play().catch(err => console.log("Auto-play blocked or interrupted"));
    }
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
    }
  };

  return (
    <div 
      className="project-card"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={() => onOpen(project)}
    >
      <div className="card-media-wrapper">
        <img 
          src={project.image} 
          alt={project.title} 
          className={`card-cover-image ${isHovered && project.hoverVideo ? 'hidden' : ''}`}
        />
        {project.hoverVideo && (
          <video
            ref={videoRef}
            src={project.hoverVideo}
            muted
            loop
            playsInline
            className={`card-hover-video ${isHovered ? 'visible' : ''}`}
          />
        )}
        <div className="card-glow-overlay"></div>
      </div>
      {project.comingSoon && (
        <div className="coming-soon-badge">
          <Sparkles size={11} className="coming-soon-sparkle" />
          <span>Coming Soon</span>
        </div>
      )}
      <div className="card-content-overlay">
        <span className="card-category-tag">{project.category}</span>
        <h3 className="card-title">{project.title}</h3>
        <p className="card-subtitle">{project.role}</p>
        
        <div className="card-tech-badges">
          {project.technologies.slice(0, 3).map((tech, idx) => (
            <span key={idx} className="tech-badge">{tech}</span>
          ))}
          {project.technologies.length > 3 && (
            <span className="tech-badge-more">+{project.technologies.length - 3}</span>
          )}
        </div>
      </div>
    </div>
  );
};

const Experience = () => {
  const [activeFilter, setActiveFilter] = useState('all');
  const [selectedProject, setSelectedProject] = useState(null);
  const [currentAssetIdx, setCurrentAssetIdx] = useState(0);

  const filteredProjects = activeFilter === 'all' 
    ? projectsData 
    : projectsData.filter(p => p.category === activeFilter);

  const openLightbox = (project) => {
    setSelectedProject(project);
    setCurrentAssetIdx(0);
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    setSelectedProject(null);
    document.body.style.overflow = 'auto';
  };

  const handleNextAsset = (e) => {
    e.stopPropagation();
    if (!selectedProject) return;
    setCurrentAssetIdx((prev) => (prev + 1) % selectedProject.assets.length);
  };

  const handlePrevAsset = (e) => {
    e.stopPropagation();
    if (!selectedProject) return;
    setCurrentAssetIdx((prev) => (prev - 1 + selectedProject.assets.length) % selectedProject.assets.length);
  };

  const currentAsset = selectedProject?.assets[currentAssetIdx];

  return (
    <section id="experience" className="experience-section">
      <div className="experience-container">
        
        {/* Header Section */}
        <div className="experience-header">
          <div className="experience-tag">
            <Sparkles size={16} className="text-purple-accent" />
            <span>Showcase</span>
          </div>
          <h2 className="experience-section-title">
            Featured <span className="text-purple-gradient">Projects</span> & Works
          </h2>
          <p className="experience-subtitle">
            A detailed look into the digital worlds I have built. Select a category and hover over the cards to see the projects in action.
          </p>
        </div>

        {/* Categories / Filter tabs */}
        <div className="filter-tabs-wrapper">
          <div className="filter-tabs">
            {categories.map((cat) => {
              const Icon = cat.icon;
              const count = cat.id === 'all' 
                ? projectsData.length 
                : projectsData.filter(p => p.category === cat.id).length;
                
              return (
                <button
                  key={cat.id}
                  className={`filter-tab-btn ${activeFilter === cat.id ? 'active' : ''}`}
                  onClick={() => setActiveFilter(cat.id)}
                >
                  <Icon size={16} />
                  <span>{cat.label}</span>
                  <span className="filter-count-badge">{count}</span>
                </button>
              );
            })}
          </div>
        </div>

        {/* Projects Grid */}
        <div className="projects-grid">
          {filteredProjects.map((project) => (
            <ProjectCard 
              key={project.id} 
              project={project} 
              onOpen={openLightbox} 
            />
          ))}
        </div>

      </div>

      {/* Glassmorphic Lightbox Modal */}
      {selectedProject && (
        <div className="lightbox-overlay" onClick={closeLightbox}>
          <div className="lightbox-content-card" onClick={(e) => e.stopPropagation()}>
            <button className="lightbox-close-btn" onClick={closeLightbox}>
              <X size={24} />
            </button>

            {/* Visual Part */}
            <div className="lightbox-visual-pane">
              <div className="lightbox-media-viewport">
                {currentAsset?.type === 'video' ? (
                  <video 
                    key={currentAsset.src}
                    src={currentAsset.src} 
                    controls 
                    autoPlay 
                    className="viewport-video"
                  />
                ) : (
                  <img 
                    src={currentAsset?.src} 
                    alt={currentAsset?.title} 
                    className="viewport-image"
                  />
                )}

                {/* Navigation Arrows */}
                {selectedProject.assets.length > 1 && (
                  <>
                    <button className="nav-arrow prev-arrow" onClick={handlePrevAsset}>
                      <ChevronLeft size={24} />
                    </button>
                    <button className="nav-arrow next-arrow" onClick={handleNextAsset}>
                      <ChevronRight size={24} />
                    </button>
                  </>
                )}

                {/* Media Indicator / Dots */}
                <div className="media-dots-indicator">
                  {selectedProject.assets.map((_, idx) => (
                    <span 
                      key={idx} 
                      className={`media-dot ${currentAssetIdx === idx ? 'active' : ''}`}
                      onClick={() => setCurrentAssetIdx(idx)}
                    />
                  ))}
                </div>
              </div>

              {/* Thumbnails list */}
              {selectedProject.assets.length > 1 && (
                <div className="lightbox-thumbnails-strip">
                  {selectedProject.assets.map((asset, idx) => (
                    <div 
                      key={idx} 
                      className={`thumbnail-item ${currentAssetIdx === idx ? 'active' : ''}`}
                      onClick={() => setCurrentAssetIdx(idx)}
                    >
                      {asset.type === 'video' ? (
                        <div className="thumbnail-video-placeholder">
                          <Play size={16} className="play-icon" />
                          <video src={asset.src} muted className="thumb-video-preview" />
                        </div>
                      ) : (
                        <img src={asset.src} alt="" className="thumb-img-preview" />
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Info Part */}
            <div className="lightbox-info-pane">
              <div className="info-pane-header">
                <div className="info-header-left">
                  <span className="info-year">{selectedProject.year}</span>
                  {selectedProject.comingSoon && (
                    <span className="lightbox-coming-soon-badge">
                      <Sparkles size={12} className="coming-soon-sparkle" />
                      Coming Soon
                    </span>
                  )}
                </div>
                <span className="info-company">{selectedProject.company}</span>
              </div>
              
              <h2 className="info-title">{selectedProject.title}</h2>
              <h4 className="info-role">{selectedProject.role}</h4>
              
              <div className="info-description-scroll">
                <p className="info-description">{selectedProject.description}</p>
              </div>

              <div className="info-footer">
                <div className="info-tech-section">
                  <span className="info-section-label">Technologies used</span>
                  <div className="info-tech-badges">
                    {selectedProject.technologies.map((tech, idx) => (
                      <span key={idx} className="info-tech-badge">{tech}</span>
                    ))}
                  </div>
                </div>

                {selectedProject.externalLink && (
                  <a 
                    href={selectedProject.externalLink} 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="info-external-btn"
                  >
                    <span>View Final Version</span>
                    <ExternalLink size={16} />
                  </a>
                )}
              </div>
            </div>

          </div>
        </div>
      )}
    </section>
  );
};

export default Experience;
